import { hot } from 'react-hot-loader/root';
import Component from './distressIncidents-view';

export default hot(Component);
